export default function Device({ color }: { color: string; }) {
  return (
    <svg width='24' height='24' viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.7 10.8C11.2982 12.0573 10.2882 13.0627 9 13.5001M9.00004 16.2001C6.0225 16.2001 3.6 13.9185 3.6 11.1141C3.6 7.20005 9.00008 1.80005 9.00008 1.80005C9.00008 1.80005 14.4 7.20005 14.4 11.1141C14.4 13.9185 11.9776 16.2001 9.00004 16.2001Z" stroke={color} strokeOpacity='1' strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}